import { render, staticRenderFns } from "./PrintLogs.vue?vue&type=template&id=1d923c92&"
import script from "./PrintLogs.vue?vue&type=script&lang=js&"
export * from "./PrintLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports